module.exports = __webpack_public_path__ + "img/user-11.d80ac14b.svg";